/* eslint-disable */

import { APPS, CaseManager, FEATURES } from "@stacc/flow-case-manager";
import React from "react";
import { useNavigate } from "react-router-dom";
import Branding from "../branding/Branding";
import { Header } from "../branding/Header";
import LoginLogo from "../branding/LoginLogo";
import { AgentManagerIcon } from "../components/Icons/AgentManagerIcon";
import translatesInbox from "../translate/inbox.json";
import translatesProcess from "../translate/process.json";
import { isTestEnvironment } from "../utils/environment.helper";
import * as case_and_queue_config from "./case-and-queue-config";
import { searchConfiguration } from "./search-configuration";

type CustomWindow = {
  stacc_env?: any;
};

export const Portal = () => {
  const AgentManagerRedirect: React.FC = () => {
    const navigate = useNavigate();
    React.useEffect(() => {
      window.open(
        // TODO: Move to env variable??
        isTestEnvironment()
          ? "https://agent-manager.test.quattro.stacc.dev/"
          : "https://agent-manager.prod.quattro.stacc.dev/",
        "_blank",
        "noopener,noreferrer"
      );
      navigate("/inbox", { replace: true });
    }, [navigate]);
    return null;
  };

  const leaBankTheme = {
    mainLogo: () => {
      return <Header />;
    },
    branding: Branding,
    customerIcon: LoginLogo
  };

  const customTranslations = [
    {
      app: APPS.Inbox,
      language: "en",
      translates: translatesInbox
    },
    {
      app: APPS.Process,
      language: "en",
      translates: translatesProcess
    }
  ];
  return (
    <CaseManager
      configuration={() => {
        return {
          homeUrl: "/inbox",
          language: "en",
          skin: leaBankTheme,
          apps: [APPS.Inbox, APPS.Search, APPS.Process],
          inboxConfiguration: {
            features: [FEATURES.CaseNotes],
            queuesPollingEnabled: true,
            startableProcesses: [
              "loan-es",
              "manual-cleanup",
              "common-process",
              "psd2-cleanup"
            ]
          },
          searchConfiguration: searchConfiguration,
          caseNotesConfiguration: {
            sort: "DESC",
            flowStatusesAllowingNewNotes: [
              "active",
              "completed"
            ] /* "completed", "archived" */
          },
          customComponents: case_and_queue_config.CustomComponents(),
          customRoutes: [
            {
              path: "/agentManager",
              component: AgentManagerRedirect,
              navigation: {
                title: "Agent Manager",
                icon: () => <AgentManagerIcon />
              }
            }
          ],
          translates: customTranslations
        };
      }}
    />
  );
};
